/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // --- Line item property: compteur de caractères restants ---
  function updatePropertiesCounter(input) {
    var max = parseInt(input.getAttribute('maxlength'), 10);
    if (!max) return;
    var wrapper = input.closest('.product__block') || input.parentNode;
    var count = wrapper && wrapper.querySelector('[data-properties-counter] [data-count]');
    if (count) count.textContent = max - input.value.length;
  }

  // Mise à jour en temps réel (délégation -> robuste aux champs ré-injectés)
  document.addEventListener('input', function(e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('properties__input') && t.hasAttribute('maxlength')) {
      updatePropertiesCounter(t);
    }
  });

  function initPropertiesCounters() {
    document.querySelectorAll('.properties__input[maxlength]').forEach(updatePropertiesCounter);
  }

  if (document.readyState !== 'loading') {
    initPropertiesCounters();
  } else {
    document.addEventListener('DOMContentLoaded', initPropertiesCounters);
  }

  // --- Article: table of contents (sommaire) ---
  // The sommaire and its heading anchors are rendered server-side in Liquid
  // (sections/article.liquid) so they are present in the raw HTML for every
  // crawler. This handler only adds smooth scrolling and keeps a shareable hash.
  function initArticleToc() {
    var toc = document.querySelector('.article__toc');
    if (!toc) return;

    toc.addEventListener('click', function(e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;
      var target = document.getElementById(decodeURIComponent(link.getAttribute('href').slice(1)));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (history.replaceState) {
        history.replaceState(null, '', link.getAttribute('href'));
      }
    });
  }

  if (document.readyState !== 'loading') {
    initArticleToc();
  } else {
    document.addEventListener('DOMContentLoaded', initArticleToc);
  }

  // --- Color info lightbox (lien "En savoir plus sur nos couleurs") ---
  // <button data-color-info-open="ID"> ouvre le <dialog id="ID">.
  // Délégation globale -> robuste au re-render de <variant-selects>.
  document.addEventListener('click', function(e) {
    var opener = e.target.closest('[data-color-info-open]');
    if (opener) {
      var dlg = document.getElementById(opener.getAttribute('data-color-info-open'));
      if (dlg && typeof dlg.showModal === 'function') {
        e.preventDefault();
        dlg.showModal();
      }
      return;
    }

    var closer = e.target.closest('[data-color-info-close]');
    if (closer) {
      var d = closer.closest('dialog');
      if (d) d.close();
      return;
    }

    // Clic sur le fond (backdrop) du dialog -> fermeture
    if (e.target.matches && e.target.matches('dialog.color-info__dialog')) {
      e.target.close();
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
